const buildContentQuery = (filterClause, sortClause, page) => `
                {
                  content(per_page: 12, page : ${page}, ${filterClause} ${sortClause}) {
                    total
                    items {
                      content_id
                      title
                      uri_stem
                      description
                      page_url
                      asset{
                        asset_type
                        youtube{
                            youtube_id
                            height
                            width
                            duration
                            thumbnail
                            youtube_url
                        }
                        photo{
                          sources{
                            height
                            width
                            url
                          }
                          thumbnails{
                            url
                            height
                            width
                          }
                        }
                        video{
                          duration
                          thumbnails{
                            url
                            height
                            width
                          }
                          sources{
                            hls
                            dash
                            mp4{
                              height
                              width
                              url
                            }
                          }
                        }
                      }
                      creator{
                        creator_id
                        full_name
                        thumbnail
                      }
                      products{
                         product_id
                         title
                         image
                         link
                         price
                         sale_price
                         description
                      }
                    creator {
                        creator_id
                        employee_id
                        uri_stem
                        thumbnail
                        first_name
                        full_name
                        last_name
                        region {
                            name
                        }
                        store {
                            name
                            store_number
                        }
                    }
                      attributes{
                        code,
                        value
                      }
                      content_type,
                      creation_date
                    }
                  }
                }
`;

const creatorFilter = (creatorId) => `{creator_id: ${creatorId} }`;

const wrapFilters = (contentFilters) => `, filter: {
            AND:[
                ${contentFilters}
            ]
            }`;

module.exports = { buildContentQuery, creatorFilter, wrapFilters };
